import { ORG_CODE_INPUT_ID } from './org-code-field.util';

/**
 * Wires task-pane button and filter controls. Call once from `Office.onReady` after the DOM exists.
 */
export function setupTaskpaneActionHandlers(handlers: {
    onOrgCodeInput: () => void;
    onConnectClick: () => void;
    onSwitchOrganisationCancelClick: () => void;
    onFetchReport: () => void;
    onRefreshReportData: () => void;
    onReportTargetChange: () => void;
    onFilterRecordTypeChange: () => void;
    /** Sync-only (e.g. org code input) — does not clear filter validation outlines. */
    onFiltersDomActivity: () => void;
    /** Delegated from `#report-filters-panel` — clears field error outlines then syncs refresh. */
    onReportFiltersPanelDomActivity: () => void;
}): void {
    document.getElementById(ORG_CODE_INPUT_ID)?.addEventListener('input', () => {
        handlers.onOrgCodeInput();
        handlers.onFiltersDomActivity();
    });

    const connect = document.getElementById('connect-button');
    if (connect) {
        connect.onclick = handlers.onConnectClick;
    }

    const switchCancel = document.getElementById('switch-org-cancel-button');
    if (switchCancel) {
        switchCancel.onclick = handlers.onSwitchOrganisationCancelClick;
    }

    const fetchData = document.getElementById('fetch-data');
    if (fetchData) {
        fetchData.onclick = handlers.onFetchReport;
    }

    const refreshReportData = document.getElementById('refresh-report-data');
    if (refreshReportData) {
        refreshReportData.onclick = handlers.onRefreshReportData;
    }

    const reportTarget = document.getElementById('report-target');
    if (reportTarget) {
        reportTarget.onchange = handlers.onReportTargetChange;
    }

    const filterRecordType = document.getElementById('filter-record-type');
    if (filterRecordType) {
        filterRecordType.onchange = handlers.onFilterRecordTypeChange;
    }

    const reportFiltersPanel = document.getElementById('report-filters-panel');
    if (reportFiltersPanel) {
        reportFiltersPanel.addEventListener('input', handlers.onReportFiltersPanelDomActivity);
        reportFiltersPanel.addEventListener('change', handlers.onReportFiltersPanelDomActivity);
    }
}
